/*! Yubico Japan — back-in-stock signup (再入荷のお知らせ).
   Posts the Shopify customer form (snippets/back-in-stock.liquid) in the
   background so the shopper stays on the product. If Shopify answers with a
   captcha challenge, falls back to a normal form submit. */
(function () {
  "use strict";
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function show(box, text, kind) {
    var m = box.querySelector(".bis__msg");
    if (!m || !text) return;
    m.textContent = text;
    m.className = "bis__msg is-" + kind;
    m.hidden = false;
  }

  // Thank-you popup — same modal as the 問い合わせ (contact form) acknowledgement
  // (.modal-root / .modal markup from sections/contact-form.liquid, styled by redesign.css).
  function popup(t) {
    try {
      t = t || {};
      var old = document.getElementById("bisSentModal"); if (old) old.parentNode.removeChild(old);
      var prevFocus = document.activeElement;
      var m = document.createElement("div");
      m.className = "modal-root"; m.id = "bisSentModal"; m.setAttribute("aria-hidden", "false");
      m.innerHTML =
        '<div class="modal-overlay js-modal-close"></div>' +
        '<div class="modal" role="dialog" aria-modal="true" aria-labelledby="bisSentTitle" aria-describedby="bisSentBody">' +
          '<button class="modal__close js-modal-close" type="button"><svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg></button>' +
          (t.mascot ? '<span class="modal__mascot" aria-hidden="true"><img alt=""></span>' : '') +
          '<h2 class="modal__title" id="bisSentTitle"></h2>' +
          '<p class="modal__body" id="bisSentBody"></p>' +
          '<button class="btn btn--primary btn--lg js-modal-close bis-sent__ok" type="button"></button>' +
        '</div>';
      var closeLabel = t.close || "閉じる";
      m.querySelector(".modal__close").setAttribute("aria-label", closeLabel);
      if (t.mascot) m.querySelector(".modal__mascot img").src = t.mascot;
      m.querySelector(".modal__title").textContent = t.title || "ご登録ありがとうございます";
      m.querySelector(".modal__body").textContent = t.text || "入荷しましたら、ご登録のメールアドレスにお知らせいたします。";
      var ok = m.querySelector(".bis-sent__ok"); ok.textContent = closeLabel;
      function close() {
        document.removeEventListener("keydown", onKey);
        m.classList.remove("is-open"); m.setAttribute("aria-hidden", "true");
        setTimeout(function () { if (m.parentNode) m.parentNode.removeChild(m); }, 400);
        try { if (prevFocus && prevFocus.focus) prevFocus.focus(); } catch (_) {}
      }
      function onKey(e) { if (e.key === "Escape") close(); }
      m.addEventListener("click", function (e) { if (e.target.closest && e.target.closest(".js-modal-close")) close(); });
      document.addEventListener("keydown", onKey);
      document.body.appendChild(m);
      requestAnimationFrame(function () { requestAnimationFrame(function () { m.classList.add("is-open"); ok.focus(); }); });
    } catch (_) {}
  }
  function popupText(box) {
    return { title: box.getAttribute("data-popup-title"), text: box.getAttribute("data-popup-text"), close: box.getAttribute("data-popup-close"), mascot: box.getAttribute("data-popup-mascot") };
  }

  function nativeSubmit(form, box) {
    try { sessionStorage.setItem("yubiBisPosted", JSON.stringify({ h: box.getAttribute("data-handle") || "", msg: box.getAttribute("data-msg-success") || "", popup: popupText(box) })); } catch (_) {}
    HTMLFormElement.prototype.submit.call(form);
  }

  // Back from a normal (challenge) submit: show the thank-you on the form that was used.
  function showReturnSuccess() {
    try {
      if (!/customer_posted=true/.test(location.search)) return;
      var saved = sessionStorage.getItem("yubiBisPosted"); if (!saved) return;
      sessionStorage.removeItem("yubiBisPosted");
      var info = JSON.parse(saved), done = false;
      Array.prototype.forEach.call(document.querySelectorAll("[data-bis]"), function (box) {
        if (done || box.hidden || box.getAttribute("data-handle") !== info.h) return;
        var row = box.querySelector(".bis__row"); if (row) row.hidden = true;
        show(box, info.msg || box.getAttribute("data-msg-success"), "success");
        if (box.tagName === "DETAILS") box.open = true;
        if (box.scrollIntoView) box.scrollIntoView({ block: "center" });
        done = true;
      });
      popup(info.popup);
      if (false) {
        var n = document.createElement("div");
        n.setAttribute("role", "status");
        n.textContent = info.msg;
        n.style.cssText = "position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:9999;max-width:90vw;padding:14px 20px;border-radius:14px;background:#0b6b2c;color:#fff;font-weight:700;box-shadow:0 8px 24px rgba(0,0,0,.18)";
        document.body.appendChild(n);
        setTimeout(function () { if (n.parentNode) n.parentNode.removeChild(n); }, 7000);
      }
      try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: "back_in_stock_signup", product_handle: info.h }); } catch (_) {}
    } catch (_) {}
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", showReturnSuccess); else showReturnSuccess();

  // Shopify Forms (inside .bis__app): its UI may live in a shadow root. After the
  // shopper interacts, watch for the form's success text, then show our popup.
  (function watchForms() {
    try {
      var app = document.querySelector("[data-bis] .bis__app"); if (!app) return;
      var box = app.closest("[data-bis]"), done = false, timer = null;
      var needle = box.getAttribute("data-popup-title") || "ご登録ありがとうございます";
      function textOf(node) {
        var out = "";
        (function walk(e) {
          if (!e) return;
          if (e.shadowRoot) walk(e.shadowRoot);
          var kids = e.children || [];
          if (!kids.length) { out += " " + (e.textContent || ""); return; }
          for (var i = 0; i < kids.length; i++) walk(kids[i]);
        })(node);
        return out;
      }
      function start() {
        if (done || timer) return;
        var n = 0;
        timer = setInterval(function () {
          n++;
          if (n > 120) { clearInterval(timer); timer = null; return; }
          if (textOf(app).indexOf(needle) >= 0) {
            clearInterval(timer); timer = null; done = true;
            popup(popupText(box));
            try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: "back_in_stock_signup", product_handle: box.getAttribute("data-handle") }); } catch (_) {}
          }
        }, 700);
      }
      app.addEventListener("click", start, true);
      app.addEventListener("submit", start, true);
      app.addEventListener("keydown", function (e) { if (e.key === "Enter") start(); }, true);
    } catch (_) {}
  })();

  document.addEventListener("submit", function (e) {
    var form = e.target && e.target.closest ? e.target.closest(".js-bis-form") : null;
    if (!form || !window.fetch || !window.FormData) return;
    e.preventDefault();
    var box = form.closest("[data-bis]") || form;
    var input = form.querySelector('input[name="contact[email]"]');
    var btn = form.querySelector('button[type="submit"]');
    var email = ((input && input.value) || "").trim();
    if (!EMAIL.test(email)) { show(box, box.getAttribute("data-msg-invalid"), "error"); if (input) input.focus(); return; }
    if (form.getAttribute("data-busy")) return;
    form.setAttribute("data-busy", "1");
    var prev = btn ? btn.textContent : "";
    if (btn) { btn.disabled = true; btn.textContent = box.getAttribute("data-msg-submitting") || prev; }

    fetch(form.action, { method: "POST", body: new FormData(form), credentials: "same-origin", headers: { Accept: "text/html" } })
      .then(function (r) {
        if (r.ok && /customer_posted=true/.test(r.url)) return "ok";
        // Shopify bot protection (hCaptcha) answers 429/403 or redirects to
        // /challenge. Hand over to a normal form submit so the shopper can pass
        // the check; Shopify then returns them here with ?customer_posted=true.
        if (/\/challenge/.test(r.url) || r.status === 429 || r.status === 403) { nativeSubmit(form, box); return "native"; }
        return r.text().then(function (t) {
          if (/challenge|captcha/i.test(t)) { nativeSubmit(form, box); return "native"; }
          throw new Error("not posted");
        });
      })
      .then(function (state) {
        if (state !== "ok") return;
        var row = form.querySelector(".bis__row");
        if (row) row.hidden = true;
        show(box, box.getAttribute("data-msg-success"), "success");
        popup(popupText(box));
        try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: "back_in_stock_signup", product_handle: box.getAttribute("data-handle") });
        } catch (_) {}
      })
      // Any unexpected answer: don't show an error — hand over to a normal form
      // submit, which Shopify always processes (and redirects back with the thank-you).
      .catch(function () { try { nativeSubmit(form, box); } catch (_) { show(box, box.getAttribute("data-msg-error"), "error"); } })
      .then(function () {
        form.removeAttribute("data-busy");
        if (btn) { btn.disabled = false; btn.textContent = prev; }
      });
  });
})();


/*! Yubico Japan — live stock sync + "more stock" notice.
   - Re-checks stock in the background so open pages adapt without reload:
     product page every 60s while the tab is visible, product cards when the
     tab becomes visible again. Uses ?section_id=stock-status (flags only).
   - Crash-safe: everything is try/catch'd, one request at a time, at most 24
     cards, and it stops after 3 consecutive failures.
   - On a Shopify 422 (requested qty > available stock), cart.js fires
     "yubi:stock-limit" and the restock form opens with "more stock" copy. */
(function () {
  "use strict";
  if (!window.fetch || !document.addEventListener) return;
  var MIN_GAP = 55000, PDP_EVERY = 60000, MAX_FAILS = 3, MAX_CARDS = 24;
  var fails = 0, lastPdp = 0, lastCards = Date.now(), busy = false, cache = {};
  var RE = /<script type="application\/json" data-stock-status>([\s\S]*?)<\/script>/;

  function status(handle) {
    return fetch("/products/" + encodeURIComponent(handle) + "?section_id=stock-status", { credentials: "same-origin", headers: { Accept: "text/html" } })
      .then(function (r) { if (!r.ok) throw new Error("http " + r.status); return r.text(); })
      .then(function (html) {
        var m = html.match(RE); if (!m) throw new Error("no stock data");
        var d = JSON.parse(m[1]);
        (d.variants || []).forEach(function (v) { cache[String(v.id)] = v; });
        return d;
      });
  }

  var form = document.getElementById("productForm");
  var pdp = null;
  if (form) {
    var bisEl = null, sib = form.nextElementSibling;
    while (sib) { if (sib.hasAttribute && sib.hasAttribute("data-bis")) { bisEl = sib; break; } sib = sib.nextElementSibling; }
    pdp = {
      id: form.querySelector('input[name="id"]'),
      buy: form.querySelector("[data-buy-now]"),
      add: form.querySelector("[data-variant-id]"),
      low: form.querySelector("[data-stock-low]"),
      bis: bisEl
    };
  }

  function applyPdp() {
    if (!pdp || !pdp.id) return;
    var v = cache[String(pdp.id.value)]; if (!v) return;
    var a = !!v.available;
    if (pdp.buy) { pdp.buy.hidden = !a; pdp.buy.disabled = !a; }
    if (pdp.add) {
      pdp.add.disabled = !a;
      var l = pdp.add.querySelector(".btn__label");
      var t = l && l.getAttribute(a ? "data-in-stock" : "data-sold-out");
      if (t) l.textContent = t;
    }
    if (pdp.bis && !pdp.bis.classList.contains("is-more")) pdp.bis.hidden = a;
    if (pdp.low) pdp.low.hidden = !(a && v.low);
  }

  function applyCard(ca) {
    var add = ca.querySelector("[data-variant-id]"), buy = ca.querySelector("[data-buy-now]");
    var v = add && cache[String(add.getAttribute("data-variant-id"))]; if (!v) return;
    var a = !!v.available, body = ca.parentNode;
    if (buy) { buy.hidden = !a; buy.disabled = !a; if (a && ca.getAttribute("data-label-buy")) buy.textContent = ca.getAttribute("data-label-buy"); }
    if (add) {
      add.disabled = !a;
      var l = add.querySelector(".btn__label"), t = ca.getAttribute(a ? "data-label-add" : "data-label-sold-out");
      if (l && t) l.textContent = t;
    }
    var bis = body && body.querySelector("[data-bis]");
    if (bis && !bis.classList.contains("is-more")) bis.hidden = a;
    var low = body && body.querySelector("[data-stock-low]");
    if (low) low.hidden = !(a && v.low);
  }

  function tickPdp(force) {
    if (!pdp || !pdp.bis || busy || fails >= MAX_FAILS || document.hidden) return;
    if (!force && Date.now() - lastPdp < MIN_GAP) return;
    var h = pdp.bis.getAttribute("data-handle"); if (!h) return;
    busy = true; lastPdp = Date.now();
    status(h).then(function () { fails = 0; applyPdp(); })
      .catch(function () { fails++; })
      .then(function () { busy = false; });
  }

  function syncCards() {
    if (busy || fails >= MAX_FAILS || document.hidden || Date.now() - lastCards < MIN_GAP) return;
    lastCards = Date.now();
    var groups = {};
    Array.prototype.forEach.call(document.querySelectorAll("[data-stock-handle]"), function (ca) {
      var h = ca.getAttribute("data-stock-handle"); if (h) (groups[h] = groups[h] || []).push(ca);
    });
    var handles = Object.keys(groups).slice(0, MAX_CARDS);
    if (!handles.length) return;
    busy = true;
    (function next(i) {
      if (i >= handles.length || fails >= MAX_FAILS) { busy = false; return; }
      status(handles[i])
        .then(function () { fails = 0; groups[handles[i]].forEach(function (ca) { try { applyCard(ca); } catch (_) {} }); })
        .catch(function () { fails++; })
        .then(function () { setTimeout(function () { next(i + 1); }, 150); });
    })(0);
  }

  if (pdp) setInterval(function () { try { tickPdp(false); } catch (_) {} }, PDP_EVERY);
  document.addEventListener("visibilitychange", function () {
    if (document.hidden) return;
    try { if (pdp && Date.now() - lastPdp > 15000) tickPdp(true); else syncCards(); } catch (_) {}
  });
  document.addEventListener("yubi:variant-change", function () {
    try { if (pdp && pdp.id && cache[String(pdp.id.value)]) applyPdp(); else tickPdp(true); } catch (_) {}
  });

  // Requested quantity exceeded available stock → open the restock form ("more stock" copy).
  document.addEventListener("yubi:stock-limit", function (e) {
    try {
      var det = e.detail || {}, btn = det.button;
      var ca = btn && btn.closest ? btn.closest(".card-actions") : null;
      var bis = det.drawer ? document.querySelector("#cartDrawer [data-bis]")
        : (ca ? ca.parentNode.querySelector("[data-bis]") : (pdp && pdp.bis));
      if (!bis) return;
      var mt = bis.getAttribute("data-msg-more-title"), mx = bis.getAttribute("data-msg-more-text");
      bis.classList.add("is-more");
      var title = bis.querySelector(".bis__title"), text = bis.querySelector(".bis__text"), sum = bis.querySelector("summary");
      if (title && mt) title.textContent = mt;
      if (sum && mt) sum.textContent = mt;
      if (text && mx) text.textContent = mx;
      var tags = bis.querySelector('input[name="contact[tags]"]');
      if (det.drawer && tags) tags.value = bis.getAttribute("data-bis-tags") + (det.handle ? ", restock-" + det.handle : "");
      if (det.drawer && title && mt && det.title) title.textContent = mt + "（" + det.title + "）";
      var go = bis.querySelector("[data-bis-go]");
      if (go && det.drawer && det.handle) go.setAttribute("href", "/products/" + encodeURIComponent(det.handle) + "#restock");
      if (tags && tags.value.indexOf("restock-more") < 0) tags.value += ", restock-more";
      bis.hidden = false;
      if (bis.tagName === "DETAILS") bis.open = true;
      if (bis.scrollIntoView) bis.scrollIntoView({ behavior: "smooth", block: "nearest" });
    } catch (_) {}
  });
})();


/*! Shopify Forms restyle: the Forms widget renders in an (open) shadow root
   with its own fonts/padding. Inject theme-matching CSS so it looks like the
   original 再入荷のお知らせ card: compact title/text, email + button in one row
   on desktop (stacked on mobile), small consent note. Class names are matched
   by prefix ([class*="_formHeader_"]) because Shopify hashes the suffixes. */
(function () {
  "use strict";
  var CSS = ":host{--spacing-size:0px;--spacing-size-y:0px;--spacing-size-x:0px;--app-embed-padding-x:0px;--app-embed-padding-y:0px}\n*{font-family:inherit !important;box-sizing:border-box !important}\n[class*=\"_appEmbed_\"],[class*=\"_container_\"],[class*=\"_inline_\"],[class*=\"_formContainer_\"],[class*=\"_gridItem_\"]{padding:0 !important;margin:0 !important;background:transparent !important;box-shadow:none !important;border:0 !important;max-width:none !important;width:100% !important;min-height:0 !important}\n[class*=\"_grid_\"]{display:block !important}\n[class*=\"_imageLoading_\"]{display:none !important}\n[class*=\"_formHeader_\"]{margin:0 0 12px !important;padding:0 !important;gap:0 !important;text-align:left !important}\n[class*=\"_textHeading_\"]{margin:0 0 4px !important;font-size:16px !important;font-weight:700 !important;line-height:1.5 !important;letter-spacing:normal !important;color:var(--color-ink,#06231A) !important;text-align:left !important}\n[class*=\"_textBody_\"],[class*=\"_textBody_\"] p{margin:0 !important;font-size:14px !important;line-height:1.7 !important;color:var(--color-muted,#5C7268) !important;text-align:left !important}\nform{display:grid !important;grid-template-columns:minmax(0,1fr) auto !important;gap:8px !important;align-items:start !important;margin:0 !important;padding:0 !important}\nform>*{margin:0 !important}\nform>div:not([class*=\"_formFieldContainer_\"]){display:none !important}\nform [class*=\"_formFieldContainer_\"][class]{overflow:visible !important;min-width:0 !important;width:auto !important;height:48px !important;min-height:0 !important;max-height:48px !important;align-items:center !important}\n[class*=\"_formInputFieldLabel_\"]{display:none !important}\nform>button,[class*=\"_formSubmitButton_\"]{flex:0 0 auto !important;display:inline-flex !important;align-items:center !important;justify-content:center !important;line-height:1 !important;width:auto !important;height:48px !important;min-height:48px !important;padding:0 24px !important;margin:0 !important;border-radius:var(--radius-control,var(--radius-md,10px)) !important;font-size:15px !important;font-weight:700 !important;white-space:nowrap !important}\n[class*=\"_formInputField_\"]{box-sizing:border-box !important;position:static !important;inset:auto !important;transform:none !important;margin:0 !important;min-width:0 !important;max-width:100% !important;width:100% !important;height:48px !important;padding:0 12px !important;border:1px solid var(--color-border,#DCE3DF) !important;box-shadow:none !important;outline:none !important;border-radius:var(--radius-control,var(--radius-md,10px)) !important;font-size:16px !important;background:#fff !important}\n[class*=\"_formInputField_\"]:focus{outline:none !important;border-color:var(--color-brand,#014421) !important}\n[class*=\"_formDisclaimer_\"],[class*=\"_formDisclaimer_\"] p{margin:0 !important;font-size:12px !important;line-height:1.6 !important;color:var(--color-faint,#8A9A93) !important;text-align:left !important}\n[class*=\"_formDisclaimer_\"]{margin-top:8px !important}\n@media (max-width:480px){form{grid-template-columns:minmax(0,1fr) !important}form>button,[class*=\"_formSubmitButton_\"]{width:100% !important}}\n[class*=\"_formInputField_\"]::placeholder{color:var(--color-faint,#8A9A93) !important;opacity:1 !important}\n*,*::before,*::after{animation:none !important;transition:none !important}\n[class*=\"_textHeading_\"],[class*=\"_textBody_\"],[class*=\"_textBody_\"] p,[class*=\"_formDisclaimer_\"],[class*=\"_formDisclaimer_\"] p{word-break:auto-phrase !important;line-break:strict !important;text-wrap:pretty !important;overflow-wrap:normal !important;text-align:start !important;letter-spacing:normal !important}\n[class*=\"_fadeAnimation_\"]{opacity:1 !important}";
  var PH = "メールアドレス";
  function fix(host) {
    try {
      var sr = host && host.shadowRoot; if (!sr) return false;
      if (!sr.getElementById("yubi-forms-style")) {
        var s = document.createElement("style"); s.id = "yubi-forms-style"; s.textContent = CSS; sr.appendChild(s);
      }
      var i = sr.querySelector('input[type="email"], input#email');
      if (i && i.getAttribute("placeholder") !== PH) i.setAttribute("placeholder", PH);
      if (!host.__yubiObs && window.MutationObserver) {
        host.__yubiObs = new MutationObserver(function () {
          var j = sr.querySelector('input[type="email"], input#email');
          if (j && j.getAttribute("placeholder") !== PH) j.setAttribute("placeholder", PH);
          if (!sr.getElementById("yubi-forms-style")) { var s2 = document.createElement("style"); s2.id = "yubi-forms-style"; s2.textContent = CSS; sr.appendChild(s2); }
        });
        host.__yubiObs.observe(sr, { childList: true, subtree: true });
      }
      return !!i;
    } catch (_) { return true; }
  }
  // Swap placeholder → real form only once it's styled (no flash of Shopify's default look).
  function ready(host) {
    try {
      var a = host.closest ? host.closest(".bis__app") : null;
      if (a && !a.classList.contains("is-ready")) { a.classList.add("is-ready"); window.__bisReadyAt = Math.round(performance.now()); }
    } catch (_) {}
  }
  function revealAll() {
    Array.prototype.forEach.call(document.querySelectorAll(".bis__app"), function (a) { a.classList.add("is-ready"); });
  }
  var started = Date.now();
  (function poll() {
    try {
      var hosts = document.querySelectorAll(".bis__app shopify-forms-embed"), done = hosts.length > 0;
      for (var k = 0; k < hosts.length; k++) { if (fix(hosts[k])) ready(hosts[k]); else done = false; }
      if (done) return;
      if (Date.now() - started > 8000) { revealAll(); return; } // safety: never leave the form hidden
    } catch (_) { revealAll(); return; }
    if (window.requestAnimationFrame) requestAnimationFrame(poll); else setTimeout(poll, 16);
  })();
})();
